import ArrowLeft01Icon from "../../main/icons/arrow-left-01-stroke-rounded.tsx";
import ArrowRight01Icon from "../../main/icons/arrow-right-01-stroke-rounded.tsx";
import styles from "./CandidatsWeekChooser.module.css";
import {Button} from "@/components/ui/button";

export interface CandidatsWeekChooserProps {
  onPrevWeekCandidates: () => void;
  onNextWeekCandidates: () => void;
  semaineEnCours: string;
}

const CandidatsWeekChooser = (props: CandidatsWeekChooserProps) => {
  const { onPrevWeekCandidates, onNextWeekCandidates, semaineEnCours } = props;
  return (
    <div>
      <div className={styles.row}>
        <Button
          onClick={onPrevWeekCandidates}
          id="button_prev_week_candidates"
          size="icon"
          variant="ghost"
          aria-label="Semaine précédente"
        >
          <ArrowLeft01Icon />
        </Button>
        <div className={styles.week}>{semaineEnCours}</div>
        <Button
          onClick={onNextWeekCandidates}
          id="button_next_week_candidates"
          size="icon"
          variant="ghost"
          aria-label="Semaine suivante"
        >
          <ArrowRight01Icon />
        </Button>
      </div>
    </div>
  );
};

export default CandidatsWeekChooser;
